import axios from './axios';
import store from '../store';

const getProducts = async (page, location, types,new_only, product_level, service, specifications) => {
  try {
    const res = await axios.get('/products', {
      params: {
        page,
        location,
        types,
        new_only: new_only ? +new_only : null,
	product_level: product_level ? product_level : null,
        service,
	specifications
      },
    });
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

const getProduct = async (id) => {
  try {
    const res = await axios.get(`/products/${id}`);
    return res.data.product;
  } catch (err) {
    console.error(err);
  }
};

const getServices = async () => {
  try {
    const res = await axios.get(`/services`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};


const locationsSearch = async (query) => {
  try {
//    const res = await axios.get(`/locations/${encodeURIComponent(query)}`);
       const res = await axios.get(`/locations/${query}`);
 return res.data;
  } catch (err) {
    console.error(err);
  }
};

const communitiesSearch = async (query) => {
  try {
   const res = await axios.get(`/communities/search-by-name/${encodeURIComponent(query)}`);
    return res.data.data;
  } catch (err) {
    console.error(err);
  }
};


const getSupplier = async (id) => {
  try {
    const res = await axios.get(`/users/${id}`);
    return res.data.user;
  } catch (err) {
    console.error(err);
  }
};

const sendContactEmail = async (body) => {
  try {
    const res = await axios.post('/contact-supplier', body);
    return res.data.success;
  } catch (err) {
    console.error(err);
  }
};

const getBuyer = async (id) => {
  try {
    const token = window.localStorage.getItem("_token");
    if (!token) {
      return;
    }
    const res = await axios.get(`/buyers/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data.data;

  } catch (err) {
    console.error(err);
  }
};

const socialAuthUser = async (provider, response) => {
  try {
    const res = await axios.post('/auth/' + provider, response);
    const buyer = res.data.buyer;
    store.dispatch('setBuyer', res.data.buyer);
    return buyer;
  } catch (err) {
    console.error(err);
  }
};

const addBookmark = async (product_id, buyer_id) => {
  try {
    const res = await axios.post('/bookmarks', { product_id, buyer_id });
    return res.data.success;
  } catch (err) {
    console.error(err);
  }
};

const getBookmarks = async (buyer_id) => {
  try {
    const res = await axios.get('/bookmarks', { params: { buyer_id } });
    return res.data.bookmarks;
  } catch (err) {
    console.error(err);
  }
};

const deleteBookmark = async (id) => {
  try {
    const res = await axios.delete('/bookmarks/' + id);
    return res.data.success;
  } catch (err) {
    console.error(err);
  }
};

const getSupplierServices = async (id) => {
  try {
    const res = await axios.get(`/supplier_services/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

const getSupplierDetails = async (id) => {
  try {
    const res = await axios.get(`/supplier_details/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

const getRelatedProducts = async (product_id, service_id) => {
  try {
    const res = await axios.get(`/related_products`, {
      params: {
        product_id,
        service_id,
      },
    });
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

//product-levels
const getProductLevels = async () => {
  try {
    const res = await axios.get(`/product-levels`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

const searchByName = async (query) => {
  try {
    const res = await axios.get(`/specifications/search-by-name/${encodeURIComponent(query)}`);
    return res.data.data;
  } catch (err) {
    console.error(err);
  }
};

export {
  getProducts,
  getProduct,
  getSupplier,
  locationsSearch,
  communitiesSearch,
  sendContactEmail,
  getBuyer,
  socialAuthUser,
  addBookmark,
  getBookmarks,
  deleteBookmark,
  getSupplierServices,
  getSupplierDetails,
  getRelatedProducts,
  getServices,
  getProductLevels,
  searchByName
};
